<template>
<el-dialog @close='closeDialog' title="试题中导入题目" width="80%" :visible.sync="dialogVisible">
    <div class="questionbankImport bgc box-shadow">
        <div class="content_warp">
            <!--左侧-->
            <div class="content_left_box">
                <el-tree :data="classInfoData" node-key="id" :default-expanded-keys="[1, 2]"
                         @node-click="handleNodeClick" :expand-on-click-node="false">
                <span class="custom-tree-node" slot-scope="{node, data}">
                    <span style="margin-right: 12px;">{{node.label}}</span>
                    <span style="color: #909399;">{{data.datacount}}</span>
                </span>
                </el-tree>
            </div>
            <!--右侧-->
            <div class="content_right_box">
                <!--查询部分-->
                <div class="handle_btn_box">
                    <div class="left_div"></div>
                    <div class="right_div">
                        <el-select style="width: 108px;" v-model="topicValue" placeholder="全部题型">
                            <el-option v-for="item in topicOptions" :key="item.code" :label="item.name"
                                       :value="item.code"></el-option>
                        </el-select>
                        <el-input style="margin:0 15px; width: 180px;" v-model="keywordsValue"
                                  placeholder="请输入题目名称关键词"></el-input>
                        <el-button @click="handleQuery()" type="primary" plain>搜索</el-button>
                    </div>
                </div>
                <div class="questions_table_box">
                    <div class="selectCount">
                        <p>已选<span> {{multipleSelection.length}} </span>题</p>
                    </div>
                    <el-table ref="multipleTable" :data="tableData" style="width: 100%;" height="350px" :row-key="getRowKeys"
                              @selection-change="handleSelectionChange">
                        <el-table-column type="selection" :reserve-selection="true" width="42"></el-table-column>
                        <el-table-column label="全选" min-width="220" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div v-html="scope.row.subject"></div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <page ref="page" v-if="dialogVisible" :total="totalPage" @getList="findAllQuestionInfo"></page>
            </div>
        </div>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureBtn()">确 定</el-button>
    </div>
</el-dialog>
</template>

<script>
import {getAllHostcatalog, getAllQuestionInfo} from 'api/questionApi'
import {submitExampaperQuesImportInfo} from 'api/testPaperApi'
import Page from 'base/page/page4'
import {mapGetters, mapActions} from 'vuex'
import {question} from 'api/enumCode'

export default {
    name: 'questionbankImport',
    data() {
        return {
            dialogVisible: false,
            classId: '',
            keywordsValue: '',
            topicValue: '',
            topicOptions: question.typeList,
            totalPage: 0,
            tableData: [],
            multipleSelection: [],
            select_order_number: '',//表格select选中的条数
            select_orderId: [],//表格select复选框选中的id
            classInfoData: [],
            defaultProps: {children: 'children', label: 'label'},
            selectIds: '',
            pageId: '' //上个页面传过来的参数
        }
    },
    mounted() {
        this.findAllHostcatalog()
        this.findAllQuestionInfo()
        this.multipleSelection = []
    },
    methods: {
        // 打开弹窗
        openDialog(val) {
            // this.topicValue = ''
            this.dialogVisible = true
            this.pageId = val //获取上页面值
            this.multipleSelection = []
            this.select_orderId = []
            this.page.page = 1
        },
        // 关闭弹框
        closeDialog() {
            this.$refs.multipleTable.clearSelection()
            this.dialogVisible = false
            this.multipleSelection = []
        },
        // 获取分类菜单id
        getClassId(id, type) {
            // this.$refs.copypop.closeDialog()
            if (type === '复制题目') {
                this.copyQuestionFn(id)
            } else if (type === '转移题目') {
                this.moveQuestionToCateFn(id)
            }
        },
        // 指定一个key标识这一行的数据
        getRowKeys(row) { //记录每行的key值
            return row.innerid;
        },
        handleSelectionChange(rows) { //复选框
            this.multipleSelection = rows;
            this.select_order_number = this.multipleSelection.length;
            this.select_orderId = [];
            if (rows) {
                rows.forEach(row => {
                    if (row) {
                        this.select_orderId.push(row.innerid);
                    }
                });
            }
        },
        // 分类点击
        handleNodeClick(data) {
            // console.log(data)
            this.totalPage = 0
            this.classId = data.id
            if (data.id === 1) {
                this.classId = ''
            }
            // this.keywordsValue = ''
            // this.topicValue = ''
            this.handleQuery()
        },
        // 获取题库分类列表，按elementui树结构返回，代码需支持无限级，使用递归算法
        findAllHostcatalog() {
            this.setLoading(true)
            let params = {
                catetype: 1,
                showdefault: 1
            }
            getAllHostcatalog({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // this.classInfoData = [
                    //     {label: data.data.label, id: data.data.id, datacount: data.data.datacount, children: data.data.content}
                    // ]
                    this.classInfoData = [data.data]
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        // 获取题库试题信息列表，只获取状态正常的数据
        findAllQuestionInfo() {
            this.setLoading(true)
            let params = {
                subject: this.keywordsValue, // 题目关键词
                questiontype: this.topicValue, // 试题类型：0或者空 全部 1单选题 2多选题 3不定项选择题 4判断题 5填空题 6问答题
                cateid: this.classId, // 分类id，可为空
                page: this.$refs.page ? this.$refs.page.pagination.page : 1,
                pagesize: this.$refs.page ? this.$refs.page.pagination.pageSize : 10,
            };
            getAllQuestionInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false);
                    this.tableData = data.data.content;
                    this.totalPage = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data);
                    this.setLoading(false)
                }
            })
        },
        // 确定导入
        sureBtn() {
            this.setLoading(true);
            let params = {
                innerid: this.pageId,
                quesidinfo: this.select_orderId.join(',')
            }
            submitExampaperQuesImportInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false);
                    this.dialogVisible = false;
                    this.$message.success('导入成功');
                    this.$emit('getQueList')
                },
                error: data => {
                    this.setLoading(false);
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page,
    }
}
</script>

<style lang="scss" type="text/scss" scope>
.el-dialog__footer {
    padding: 0 0 0 0;
}

.box-shadow {
    box-shadow: 0 0 0 0;
}

.questionbankImport {
    .el-table {
        .el-table__body,
        .el-table__footer,
        .el-table__header {
            table-layout: auto;
        }
    }
    .el-table__body-wrapper {
        // height: 300px;
    }
    // min-height: 90vh;
    display: flex;
    flex-direction: column;
    .handle_btn_box {
        height: 40px;
        display: flex;
        justify-content: space-between;
        padding: 6px 10px 4px 0;
        .left_div {
            .el-button + .el-button {
                margin-left: 30px;
            }
        }
        .right_div {
            display: flex;
            .el-input__icon {
                line-height: 0;
            }
        }
    }
    .content_warp {
        // flex: 1;
        display: flex;
        height: 450px;
        /*min-height: calc(100vh - 172px);*/
        .content_left_box {
            overflow: auto;
            width: 240px;
            min-width: 240px;
            flex: 0 0 auto;
            border-right: 1px solid #eee;
            border-top: none;
            box-sizing: border-box;
            margin-right: 30px;
            margin-top: -6px;
            .el-tree-node__content {
                height: 40px;
            }
            .el-tree .el-tree-node.is-current > .el-tree-node__content {
                background-color: #FAFAFA;
                color: #409EFF;
            }
        }
        .content_left_box::-webkit-scrollbar {
            width: 6px;
        }
        .content_left_box::-webkit-scrollbar-thumb {
            border-radius: 4px;
            background: rgba(229, 229, 229, 1);
        }
        .content_left_box::-webkit-scrollbar-track {
            border-radius: 4px;
            background: #fff;
        }
        .content_right_box {
            padding-right: 20px;
            flex: 1;
            width: 0;
            padding-bottom: 30px;
            .select_handle_box {
                display: flex;
                align-items: center;
                height: 35px;
                background-color: #E6F1FC;
                border: 1px solid rgba(64, 158, 255, 1);
                box-sizing: border-box;
                margin-bottom: 20px;
                & > p {
                    padding-left: 15px;
                    padding-right: 30px;
                    color: #909399;
                }
                span {
                    color: #409EFFFF;
                }
                .handle_span {
                    cursor: pointer;
                }
                .handle_span:hover {
                    color: rgb(13, 127, 241);
                }
                .line_span {
                    margin: 0 6px;
                }
            }
            .questions_table_box {
                .selectCount {
                    position: absolute;
                    right: 40px;
                    top: 130px;
                    z-index: 999;
                    font-size: 12px;
                }
                .el-table th > .cell {
                    font-weight: bold !important;
                    // white-space: nowrap;
                    // font-size: 16px;
                }
                .el-table td {
                    padding: 13px 0;
                }
                .el-table__empty-text {
                    box-sizing: border-box;
                    line-height: 140px;
                    padding-top: 180px;
                }
                .table_row_handle_box {
                    span {
                        color: #409EFFFF;
                    }
                    .handle_span {
                        cursor: pointer;
                    }
                    .handle_span:hover {
                        color: rgb(13, 127, 241);
                    }
                    .line_span {
                        margin: 0 6px;
                    }
                }
            }
        }
    }
}

.el-dialog__wrapper {
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*text-align: left;*/
}

.el-dialog {
    /*margin: 0 !important;*/
}

.el-dialog .el-dialog__body {
    padding: 6px;
    // padding-right: 6px;
}

.dialog-footer {
    border-top: 1px solid #eee;
    padding-top: 20px;
    .el-button + .el-button {
        margin-left: 15px;
    }
}
</style>
